import { DateTime } from 'luxon';

import { Shift } from './shift';

export enum ShiftStatus {
    Open = 1,
    Closed = 2,
    Locked = 3
}

export interface WorkedShift {
    id: number;
    siteId: string;
    date: DateTime;
    shiftId: number;
    shiftStatus: ShiftStatus;
    shift: Shift;
    documentIds?: string[];
}
